import { render, staticRenderFns } from "./current_invitations.vue?vue&type=template&id=11ed99b7&scoped=true"
import script from "./current_invitations.vue?vue&type=script&lang=js"
export * from "./current_invitations.vue?vue&type=script&lang=js"
import style0 from "./current_invitations.vue?vue&type=style&index=0&id=11ed99b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed99b7",
  null
  
)

export default component.exports